import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  VehicleVisualModelDto,
  VehicleVisualModelReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import VehicleVisualModelInline, {
  VehicleVisualModelInlineProps,
} from "./VehicleVisualModelInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: VehicleVisualModelDto | VehicleVisualModelReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<VehicleVisualModelInlineProps>;
}

export default function VehicleVisualModelLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess]}
      to={ROUTE_PATH.VEHICLE_VISUAL_MODEL_VIEW({
        vehicleVisualModelId: entity?.id || entityId || "",
      })}
      content={<VehicleVisualModelInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
